import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
import Utils from '@/components/shared/helpers/Utils.js';
const state = {
  ciudades: [],
  ciudad: null
};

const getters = {
  [types.ALL_CIUDADES]: state => {
    return state.ciudades;
  },
  [types.CIUDAD]: state => {
    return state.ciudad;
  }
};

const mutations = {
  [types.MUTATE_ALL_CIUDADES]: (state, payload) => {
    state.ciudades = payload;
  },
  [types.MUTATE_CIUDAD]: (state, payload) => {
    state.ciudad = payload;
  }

};

const actions = {
  [types.ACTION_GET_ALL_CIUDADES]: ({ commit }) => {
    let request = { controller: '/Ciudad' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_CIUDADES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ALL_CIUDADES_FILTERED]: ({ commit }, payload) => {
    var userId = payload.idUser;
    let request = { controller: '/Ciudad/User/' + userId };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_CIUDADES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_CIUDAD]: ({ commit }, payload) => {
    var cityId = payload.idCiudad;
    let request = { controller: '/Ciudad/' + cityId };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_CIUDAD, response.data);
          // commit('NGUD/setCiudadSelected', response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_NEW_CIUDAD]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/Ciudad/Filled',
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.newCity
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postFile', request)
        .then(response => {
          storeInstance
            .dispatch(types.ACTION_GET_CIUDAD, { idCiudad: response.data.id })
            .then(response => {
              commit(types.MUTATE_CIUDAD, response.data);
              var items = Utils.ModifyArrayAfterSaveItem(getters[types.ALL_CIUDADES], response.data);
              commit(types.MUTATE_ALL_CIUDADES, items);
              // commit('NGUD/setCiudadSelected', response.data);
              Message.showMessage('El municipio se ha guardado con éxito.');
              resolve(response);
            });
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_CIUDAD]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/Ciudad/' + payload.idCiudad,
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.newCity
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/putFile', request)
        .then(response => {
          storeInstance
            .dispatch(types.ACTION_GET_CIUDAD, { idCiudad: response.data.id })
            .then(responseCiudad => {
              commit(types.MUTATE_CIUDAD, responseCiudad.data);
            });
          var items = Utils.ModifyArrayAfterSaveEditedItem(getters[types.ALL_CIUDADES], payload.objModify, payload.idCiudad);
          commit(types.MUTATE_ALL_CIUDADES, items);
          // commit('NGUD/setCiudadSelected', response.data);
          Message.showMessage('El municipio se ha actualizado con éxito.');
          resolve(response);
          // });
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_DELETE_CIUDAD]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/Ciudad/' + payload.idCiudad,
      filter: {}
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/deletes', request)
        .then(response => {
          commit(types.MUTATE_ALL_CIUDADES, payload.items);
          Message.showMessage('El municipio se ha eliminado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_CIUDAD_ZONAS]: ({ commit }, payload) => {
    let request = { controller: '/CiudadZona/' + payload.idCiudad + '/' + payload.idIndicador + '/' + payload.fechaInicio + '/' + payload.fechaFin };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
